'use client';

import { Toaster as SonnerToaster } from 'sonner';

export function Toaster() {
  return (
    <SonnerToaster
      theme="light"
      position="bottom-right"
      closeButton
      duration={4000}
      gap={10}
      offset={20}
      visibleToasts={4}
      icons={{
        success: null,
        error: null,
        info: null,
        warning: null,
        loading: null,
      }}
      toastOptions={{
        unstyled: true,
        classNames: {
          toast: 'dc-toast',
          title: 'dc-toast__title',
          description: 'dc-toast__description',
          content: 'dc-toast__content',
          icon: 'dc-toast__icon',
          closeButton: 'dc-toast__close',
          success: 'dc-toast--success',
          error: 'dc-toast--error',
          info: 'dc-toast--info',
          warning: 'dc-toast--warning',
        },
      }}
    />
  );
}
